import { ICamIV64File } from "services/Hardware/CamHTTP/CamIV64File";
import { BuildingsCamIV64MockMeasurements } from "./BuildingsCamIV64MockMeasurements";
import { SpecialMeasurementFileBase } from "services/Hardware/CamHTTP/ICamApi";

export class BuildingsCamIV64Mock {
    private static files(): ICamIV64File[] {
        const paths = [
            "recordings/recording1.sor",
            "recordings/recording2.sor",
            "test/test.sor",
            "test/test.jpeg",
            "recordings/fruit/banaan.sor",
            "recordings/fruit/banaan.jpeg",
            "recordings/vegetables/carrot.sor",
            "recordings/vegetables/carrot.jpeg",
            "recordings/longfilenameforasinglerecording.sor",
            "special-measurements/longfilenamespecialmeasurement.json",
            "special-measurements/rt-60.json",
            "special-measurements/sri.json",
            "test/test.json",
            "special-measurements/fruit/banaan.json",
            "special-measurements/vegetables/sri-tomato.json",
            "special-measurements/vegetables/banaan.json",
            "special-measurements/slr-test/SLR-result.json",
            "special-measurements/sri-test/SRI-result.json",
            "special-measurements/stc-test/STC-result.json",

            "z/long/path/to/the/recording/in/question.sor",
            "z/long/path/to/the/measurement/in/question.json",
        ];

        // A week ago
        const date = new Date();
        date.setDate(date.getDate() - 7);
        return paths.map((file) => {
            return { filePath: `UserData/${file}`, createDate: date } as ICamIV64File;
        });
    }

    public static normalMeasurementFiles(): ICamIV64File[] {
        return this.files().filter(
            (x) => x.filePath.toLowerCase().endsWith(".sor") || x.filePath.toLowerCase().endsWith(".jpeg")
        );
    }
    public static specialMeasurementFiles(): ICamIV64File[] {
        return this.files().filter((x) => x.filePath.toLowerCase().endsWith(".json"));
    }

    public static downloadSpecialMeasurementFile(filePath: string): SpecialMeasurementFileBase {
        if (filePath.includes("rt")) {
            return BuildingsCamIV64MockMeasurements.RT;
        } else if (filePath.includes("sri")) {
            return BuildingsCamIV64MockMeasurements.SRI;
        } else if (filePath.includes("stc")) {
            return BuildingsCamIV64MockMeasurements.STC;
        } else if (filePath.includes("slr")) {
            return BuildingsCamIV64MockMeasurements.SLR;
        } else {
            throw new Error(`No mock available for special measurement file: ${filePath}`);
        }
    }
}
